<template>
    <div>
        <v-toolbar class="glass rounded-lg" flat>
            <v-toolbar-title>
                Home Page Slider
            </v-toolbar-title>
            <v-spacer/>
            <v-dialog v-model="dialog" max-width="600">
                <template v-slot:activator="{ on, attrs}">
                    <v-btn color="primary" v-on="on" v-bind="attrs">
                        Add New
                    </v-btn>
                </template>

                <v-form @submit.prevent="addEditTeam">
                    <v-card>
                        <v-card-title class="mb-3">
                            {{ formTitle }}
                        </v-card-title>

                        <v-card-text>
                            <v-row class="mb-8">
                                <v-col>
                                    <v-file-input
                                        v-model="form.preview_image"
                                        label="Feature Image"
                                        prepend-icon=""
                                        prepend-inner-icon="mdi-camera"
                                        outlined
                                        class=""
                                        dense
                                        :error-messages="$page.props.errors.preview_image"
                                        accept="image/png, image/jpeg, image/bmp"
                                        :rules="[value => !value || value.size < 2000000 || 'Preview Image size should be less than 2 MB!',]"
                                        hint="Only .jpg or .png are allowed"
                                    />
                                </v-col>
                                <v-col >
                                    <div class="text-center mt-n10 mb-2"  >
                                        <img
                                            :src="previewFile(form.preview_image)"
                                            height="100px"
                                            class="ml-1 "
                                            alt=""
                                        />
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col class="mt-n10">
                                    <v-file-input
                                        v-model="form.background_image"
                                        label="Background Image"
                                        prepend-icon=""
                                        prepend-inner-icon="mdi-camera"
                                        outlined
                                        class=""
                                        dense
                                        :error-messages="$page.props.errors.background_image"
                                        accept="image/png, image/jpeg, image/bmp"
                                        :rules="[value => !value || value.size < 2000000 || 'Preview Image size should be less than 2 MB!',]"
                                        hint="Only .jpg or .png are allowed"
                                    />

                                    <v-switch
                                        inset
                                        :true-value="1"
                                        :false-value="0"
                                        label="Is Product Slider"
                                        v-model="form.is_product"
                                    />
                                </v-col>
                                <v-col >
                                    <div class="text-center mt-n10 mb-2"  >
                                        <img
                                            :src="previewFile(form.background_image)"
                                            height="100px"
                                            class="ml-1 "
                                            alt=""
                                        />
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col>
                                    <v-text-field
                                        outlined
                                        dense
                                        v-model="form.title"
                                        label="Title"
                                        :error-messages="$page.props.errors.title"
                                    />
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        outlined
                                        dense
                                        v-model="form.link"
                                        label="CTA Link"
                                        :error-messages="$page.props.errors.link"
                                    />
                                </v-col>
                            </v-row>
                            <v-textarea
                                rows="3"
                                outlined
                                dense
                                v-model="form.details"
                                :error-messages="$page.props.errors.details"
                                label="Member Details"
                            />
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer/>
                            <v-btn @click="close" depressed outlined color="warning" class="mx-1">
                                Cancel
                            </v-btn>

                            <v-btn type="submit" depressed   color="success" class="mx-1">
                                Submit
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-toolbar>
        <v-card>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="$page.props.sliders"
                >
                    <template v-slot:item.preview_image="{ item }">
                        <img
                            :src="item.preview_image"
                            height="90px"
                            class="ml-1"
                            alt=""
                        />
                    </template>

                    <template v-slot:item.background_image="{ item }">
                        <img
                            :src="item.background_image"
                            height="90px"
                            class="ml-1"
                            alt=""
                        />
                    </template>


                    <template v-slot:item.actions="{ item }">
                        <div class="d-flex">
                            <v-btn class="mx-1" small color="success" @click="editSlider(item)">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn class="mx-1" small color="error" @click="deleteSlider(item)">
                                <v-icon>mdi-trash-can</v-icon>
                            </v-btn>
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import AdminLayout from "../AdminLayout";
export default {
    name: "Index",
    layout:AdminLayout,
    data(){
        return {
            dialog:false,
            form:this.$inertia.form({
                id:null,
                title:null,
                details:null,
                link:null,
                preview_image:null,
                background_image:null,
                is_product:0,
            }),
            headers:[
                {text:'Title', value:'title'},
                {text:'feature Image', value:'preview_image'},
                {text:'Background Image', value:'background_image'},
                {text:'CTA', value:'link'},
                {text:'Details', value:'details'},
                {text:'Actions', value:'actions',sortable:false},
            ]
        }
    },

    computed:{

        formTitle(){

            if(this.form.id){
                return 'Edit '+this.form.title+ 'Slider'
            }else{
                return 'New Slider'
            }
        }
    },

    methods:{
        addEditTeam(){
            this.form.post(route('admin.slider.store'),{
                onSuccess:()=>{
                    this.close()
                }
            })
        },

        close(){
            this.form.reset()
            this.dialog = false
        },

        editSlider(slider){
            this.form.id               = slider.id
            this.form.title            = slider.title
            this.form.details          = slider.details
            this.form.link             = slider.link
            this.form.preview_image    = slider.preview_image
            this.form.background_image = slider.background_image
            this.dialog = true
        },

        deleteSlider(slider){
            Swal.fire({
                title: 'Are you sure?',
                text: ""+slider.title+ " will be deleted!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {

                    this.$inertia.delete(route('admin.slider.destroy',slider.id),{
                        resetOnSuccess: false,
                        onSuccess: ()=>{
                            Toast.fire({
                                icon: 'success',
                                title: 'Slider Deleted!'
                            })
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
